import styled from 'styled-components'

export const Container = styled.span`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp4};
`

export const Line = styled.span`
  display: flex;
  gap: ${props => props.theme.whiteLabel.spacing.sp4};
`
